import api from "./axios";

const AUTH_EXPIRED_EVENT = "reliablyme:auth-expired";
const KEEP_ALIVE_INTERVAL_MS = 2 * 60 * 1000;

let suppressAuthRedirect = false;
let blockingUiDepth = 0;
let keepAliveInterval: ReturnType<typeof setInterval> | null = null;

/** When true, 401 responses reject without forcing navigation (e.g. open modals). */
export function setSuppressAuthRedirect(value: boolean): void {
  suppressAuthRedirect = value;
}

export function isAuthRedirectSuppressed(): boolean {
  return suppressAuthRedirect;
}

/** While a blocking dialog (Create Commitment modal) is open, defer the global session warning. */
export function setBlockingUiOpen(open: boolean): void {
  blockingUiDepth += open ? 1 : -1;
  if (blockingUiDepth < 0) blockingUiDepth = 0;
}

export function isBlockingUiOpen(): boolean {
  return blockingUiDepth > 0;
}

/** Lightweight ping to confirm the session is still valid. */
export async function pingSession(): Promise<void> {
  await api.get("/membershortNew", { params: { page: 1, limit: 1 } });
}

export function subscribeAuthExpired(listener: () => void): () => void {
  const handler = () => listener();
  window.addEventListener(AUTH_EXPIRED_EVENT, handler);
  return () => window.removeEventListener(AUTH_EXPIRED_EVENT, handler);
}

export function emitAuthExpired(): void {
  window.dispatchEvent(new CustomEvent(AUTH_EXPIRED_EVENT));
}

/** Periodic keep-alive while a modal or session warning is active. */
export function startSessionKeepAlive(): void {
  if (keepAliveInterval) return;
  void pingSession().catch(() => {});
  keepAliveInterval = setInterval(() => {
    void pingSession().catch(() => {});
  }, KEEP_ALIVE_INTERVAL_MS);
}

export function stopSessionKeepAlive(): void {
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
    keepAliveInterval = null;
  }
}
